import type { TaxInfoFormType } from "./types";

const initialValues: TaxInfoFormType = {
  documents: "",
  taxInfo: {},
};

export { initialValues };
